export default __webpack_public_path__ + "images/logoChuda.67eda0b0f96d1903f111531dd01a3124.svg"